module.exports = require("@swa-ui/application/src/Toolbox/PlacementsUpdater.module.scss");